import script from "./CampaignsManagementDistributionRule.vue?vue&type=script&lang=ts&setup=true"
export * from "./CampaignsManagementDistributionRule.vue?vue&type=script&lang=ts&setup=true"

import "./CampaignsManagementDistributionRule.vue?vue&type=style&index=0&id=48803bb2&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48803bb2"]])

export default __exports__